import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalInterceptorConfiguration, MsalGuardConfiguration } from '@azure/msal-angular';

import { GlobalVariable } from './global';

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: GlobalVariable.SSOCLIENTID,
    authority: GlobalVariable.SSOAUTHURL,
    redirectUri: GlobalVariable.SSOREDIRECTURL,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
});

export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: {
    scopes: [
      'openid',
      'profile',
      'email',
      'user.read' // Microsoft Graph
    ],
  },
};

export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect, // Redirect or Popup (Redirect recommended)
  protectedResourceMap: new Map<string, Array<string>>([
    [GlobalVariable.SSOAPIURL, [GlobalVariable.SSOAPIID]]
  ]),
};

